import { render, staticRenderFns } from "./FormFssc22000Detail.vue?vue&type=template&id=04c0965e"
import script from "./FormFssc22000Detail.vue?vue&type=script&lang=js"
export * from "./FormFssc22000Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports